function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless imports
import { getSlideBodyComponent } from "../../../utils/HowItWorksCardHelper";
import CustomerButton from "../../customer-button/CustomerButton";
const SlideItem = ({
  classes,
  onButtonClickHandle,
  slideKey,
  shouldAnimate,
  slide,
  ...rest
}) => {
  const {
    buttonText,
    primaryColour,
    contrastColour,
    type
  } = slide;
  const SlideBody = getSlideBodyComponent(type);
  return /*#__PURE__*/React.createElement("div", {
    className: "embla__slide embla__slide_hiw"
  }, /*#__PURE__*/React.createElement("div", {
    id: `hiw-${slideKey}`,
    className: classes.container
  }, /*#__PURE__*/React.createElement(SlideBody, _extends({
    slide: slide,
    shouldAnimate: shouldAnimate
  }, rest)), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, onButtonClickHandle && /*#__PURE__*/React.createElement(CustomerButton, {
    variant: "contained",
    onClick: () => onButtonClickHandle(slideKey),
    style: {
      color: contrastColour,
      backgroundColor: primaryColour,
      width: "70%",
      boxShadow: "none"
    },
    component: "div"
  }, buttonText))));
};
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 8,
    marginBottom: 8
  }
};
export default withStyles(styles)(SlideItem);
SlideItem.propTypes = {
  classes: PropTypes.object.isRequired,
  onButtonClickHandle: PropTypes.func,
  slideKey: PropTypes.number,
  shouldAnimate: PropTypes.bool,
  slide: PropTypes.object.isRequired
};
SlideItem.defaultProps = {
  shouldAnimate: true
};